import React from 'react'

export const TEMPLATE_TYPES = [
  { key: 'single_page_pdf', label: 'PDF jednostronicowy', icon: '▯' },
  { key: 'multipage_pdf', label: 'PDF wielostronicowy', icon: '▤' },
  { key: 'presentation', label: 'Prezentacja', icon: '▣' },
]

export function TypeIcons({ available = [], active = [], compact = false }) {
  return (
    <span className={`type-icons ${compact ? 'type-icons-compact' : ''}`} aria-label="Typy szablonu">
      {TEMPLATE_TYPES.map(type => {
        const has = available.includes(type.key)
        const selected = active.includes(type.key)
        return <span key={type.key} className={`type-icon ${has ? 'is-available' : 'is-missing'} ${selected ? 'is-active' : ''}`}
          title={`${type.label}${has ? '' : ' — niedostępny'}`} aria-label={type.label}>{type.icon}</span>
      })}
    </span>
  )
}

export function TypeLabel({ type }) {
  const item = TEMPLATE_TYPES.find(x => x.key === type)
  return item ? <span className="type-label"><span aria-hidden="true">{item.icon}</span> {item.label}</span> : type
}
